import { useMyMonitoringGetSiteList } from '@apps-common/apis/my-monitoring/site'
import { SiteSelectItem } from '@apps-common/apps/my-monitoring/pages/site/components/site-select'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { IMMSiteListModel, IMMSiteModel } from '@apps-common/types/my-monitoring'

interface IProps {
  selectedSite?: IMMSiteModel
}

export const MyMonitoringSiteSelectModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IProps
}) => {
  const { selectedSite } = componentProps || {}
  const { isLoading, isError, data } = useMyMonitoringGetSiteList({})

  const onSelection = (site: IMMSiteListModel) => {
    onDismiss(site.unitId, ModalDismiss.Confirm)
  }

  const loading = !data || isLoading || isError

  return (
    <ModalContainer alwaysMobile classes='!px-0' innerClasses='!mx-0 !w-full !h-auto !min-h-0 !bg-bg' onDismiss={onDismiss}>
      <ModalHeaderContainer classes='!bg-bg'>
        <div className='flex items-start justify-between'>
          <ModalHeader title='Sites' subtitleClasses='capitalize' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} overrideClasses='bg-mm-brand text-on-mm-brand' />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[80px] !pb-[35px] flex flex-col gap-[10px]'>
        {!loading &&
          data?.map((d, i) => (
            <SiteSelectItem
              key={`site-select-modal-item-${d.siteId}-${i}`}
              selectedSite={selectedSite?.unitId}
              site={d}
              callback={() => onSelection(d)}
            />
          ))}
      </ModalBody>
    </ModalContainer>
  )
}
